import React, { Component } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import Start from './Start';
import Header from './Header';
import Footer from './Footer';
import Contact from './Contact';
import '../css/style.css';
import './Home.css';

class Home extends Component {

    render(){
        return (
            <div >
            <Container fluid className="fluid container-fluid2">
            <Row >
              <Col ><Header /></Col>
            </Row>
            
            <Row className="justify-content-md-center">
                <Col xl={8}><Start /></Col>
            </Row>
            <Row>
              <Contact />
            </Row>
            <Row>
            <Col><Footer /></Col>
            </Row>
            </Container>
          </div>
        );
    }

}

export default Home;